import "./App.scss";
import Headerbar from "./components/Headerbar";
import gilProfile1 from "./images/gilprofile1.jpg";
import doctoralia from "./images/doctoralia.png";
import drg8 from "./images/drg8.png";
import drg5 from "./images/drg5.png";
import instagram from "./icons/instagram.svg";
import whats from "./icons/whats.svg";
import google from "./icons/google.svg";
import tiktok from "./icons/tiktok.svg";
import hearth from "./icons/hearth-check.svg";
import stethoscope from "./icons/stethoscope.svg";
import virus from "./icons/virus.svg";
import clinic from "./icons/clinic.svg";
import crosshair from "./icons/crosshair.svg";
import puzzle from "./icons/puzzle.svg";
import comments from "./icons/comments.svg";
import user from "./icons/user.svg";
import Footer from "./components/footer";
import { googleReviews } from "./components/data";
import EmblaCarousel from "./components/carousel/EmblaCarousel";

// const key = process.env.REACT_APP_PLACES_API_KEY;

function App() {
  return (
    <div className="App">
      <Headerbar />
      <div id="main" className="main two-grids">
        {/* <div className="desc">
            <span className="purple">Dr. Gilberto Cascaes Guedes Neto</span>
            <p>Infectologista, Especialista em Clínica Médica</p>
          </div> */}
        <div className="right">
          <img className="drg-vetor" src={drg8} alt={"Dr. Gilberto"} />
          <p className="crm-info"> CRM-PR 43996 | RQE 30765 | RQE 36089</p>
          <p className="sub-text-head">
            Clínica Médica e <span className="bold">Infectologia</span>
          </p>
          <p className="sub-text">
            Cuidando de você de forma <span className="bold">completa</span> e{" "}
            <span className="bold">humanizada</span>.
          </p>
          <button className="call-button">
            <a
              href="https://wa.me/+5541987895126?text=Olá%2C%20gostaria%20de%20agendar%20uma%20consulta."
              target="_blank"
              rel="noreferrer"
            >
              Agende uma consulta!
            </a>
          </button>
        </div>
      </div>
      <div id="about" className="section about">
        <h2 className="section-header white">Sobre mim</h2>
        <hr className="divider-bar" />
        <div className="two-grids limit">
          <pre>
            <img className="profile1" src={gilProfile1} alt={"Dr. Gilberto"} />
          </pre>
          <div>
            <p className="about-text">
              Sou o Dr. Gilberto Cascaes Guedes Neto, médico especializado em{" "}
              <span className="bold">Clínica Médica</span> e{" "}
              <span className="bold">Infectologia</span>, unindo diagnóstico
              preciso e tratamento personalizado. <br /> Valorizo a{" "}
              <span className="bold">escuta</span> atenta, o uso das
              <span className="bold"> evidências científicas</span> mais
              recentes e o <span className="bold">cuidado integral</span> do
              paciente, sempre priorizando{" "}
              <span className="bold">bem-estar</span>,{" "}
              <span className="bold">qualidade de vida</span> e uma relação de{" "}
              <span className="bold">confiança duradoura</span>.
            </p>
            <div className="about-text-icons">
              <div>
                <img
                  src={stethoscope}
                  alt="Estetoscópio"
                  className="white-icon"
                />
                <p className="white">
                  <span className="bold">Formação de Excelência</span>: Médico
                  pela PUC-PR, Especialista em Medicina Interna pelo Hospital e
                  Maternidade São José dos Pinhais, Infectologista pelo Hospital
                  de Clínicas da Universidade Federal do Paraná
                </p>
              </div>
              <div>
                <img src={hearth} alt="Coração" className="white-icon" />
                <p className="white">
                  <span className="bold">Atendimento Humanizado</span>: Tempo
                  para ouvir, explicar e acolher as necessidades de cada
                  paciente.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="section treatments">
        <h2 className="section-header">Tratamentos para:</h2>
        <hr className="divider-bar strong" />
        <div className="treatments-cards-container">
          <div className="treatments-card">
            <h3>Infectologia:</h3>
            <p className="helper-text">
              Diagnóstico e tratamento de infecções em geral
            </p>
            <img src={virus} alt="Vírus" />
            <div>
              <p>
                • Infecções Respiratórias (Pneumonias, Sinusites, Bronquites de
                repetição)
              </p>
              <p>• Hepatites Virais (A, B, C, Delta e E)</p>
              <p>• HIV e AIDS (Pré e Pós-Exposição - PEP e PrEP)</p>
              <p>• Infecções Sexualmente Transmissíveis (ISTs)</p>
              <p>• Infecções de Pele e Tecidos Moles</p>
              <p>• Febre de Origem Desconhecida</p>
              <p>
                • Recomendações de saúde/prevenção em Viagens (Medicina do
                Viajante)
              </p>
              <p>• Infecções variadas (virus, bacterias, fungos, parasitas)</p>
            </div>
          </div>
          <div className="treatments-card">
            <h3>Clínica Médica (Medicina Interna):</h3>
            <p className="helper-text">
              A "medicina de adultos" por excelência:
            </p>
            <img src={clinic} alt="Clínica Médica" />
            <div>
              <p>• Hipertensão Arterial e Diabetes Mellitus</p>
              <p>• Doenças da Tireoide e Distúrbios Metabólicos</p>
              <p>• Check-up e Medicina Preventiva</p>
              <p>
                • Investigação de Sintomas Complexos (como fadiga, perda de peso
                inexplicada, dores)
              </p>
              <p>• Doenças Respiratórias, Gastrointestinais e Renais</p>
            </div>
          </div>
        </div>
      </div>
      <div style={{ textAlign: "center", marginBottom: "60px" }}>
        <p
          style={{ maxWidth: "70vw", margin: " 0px auto 24px" }}
          className="bold"
        >
          Está com algum desses sintomas ou precisa de uma avaliação
          especializada? Não espere para cuidar da sua saúde:
        </p>
        <button className="call-button">
          <a
            href="https://wa.me/+5541987895126?text=Olá%2C%20gostaria%20de%20agendar%20uma%20consulta."
            target="_blank"
            rel="noreferrer"
          >
            Fale comigo!
          </a>
        </button>
      </div>

      <div id="about" className="section about">
        <h2 className="section-header white">Meus diferenciais</h2>
        <hr className="divider-bar" />
        <img className="drg5" src={drg5} alt={"Dr. Gilberto"} />
        <div className="two-grids limit cards">
          <div>
            <img className="about-icon" src={puzzle} alt="Abordagem Integral" />
            <p className="about-text align-left">
              <span className="bold">Abordagem Integral</span> <br />
              <br /> A combinação única de Clínica Médica e Infectologia permite
              um diagnóstico mais abrangente, especialmente em casos complexos
              onde os sintomas se inter-relacionam.
            </p>
          </div>
          <div>
            <img
              className="about-icon"
              src={crosshair}
              alt="Diagnóstico Preciso"
            />
            <p className="about-text align-left">
              <span className="bold">Diagnóstico Preciso</span>
              <br /> <br /> Uso racional e direcionado de exames pertinentes.
            </p>
          </div>
          <div>
            <img
              className="about-icon"
              src={user}
              alt="Tratamento Personalizado"
            />
            <p className="about-text align-left">
              <span className="bold">Tratamento Personalizado</span>
              <br /> <br />
              Cada paciente é único. Seu plano de tratamento será elaborado
              especialmente para você, considerando seu estilo de vida e
              necessidades.
            </p>
          </div>
          <div>
            <img
              className="about-icon"
              src={comments}
              alt="Acesso e Comunicação"
            />
            <p className="about-text align-left">
              <span className="bold">Acesso e Comunicação</span>
              <br /> <br /> Busco manter uma comunicação clara e acessível com
              meus pacientes, tirando dúvidas e acompanhando a evolução do
              tratamento.
            </p>
          </div>
          <pre></pre>
        </div>
      </div>

      <div className="section">
        <h2 className="section-header">Local de Atendimento</h2>
        <hr className="divider-bar strong" />
        <h3>Atendimentos Presenciais e Domiciliares em Curitiba:</h3>
        <p style={{ marginTop: "0px" }}>
          Bloco Premium - Av. Anita Garibaldi, 850 - Sala 601/602 - Cabral,
          Curitiba - PR, 80540-180
        </p>
        <h3>
          Telemedicina para todo o Brasil (via{" "}
          <a
            href="https://www.doctoralia.com.br/gilberto-cascaes-guedes-neto/infectologista-especialista-em-clinica-medica/foz-do-iguacu"
            target="_blank"
            rel="noreferrer"
          >
            Doctoralia
          </a>
          )
        </h3>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            margin: "32px 0",
          }}
        >
          <iframe
            title="Mapa Dr Gilberto Cascaes Infectologista"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14613.234849247912!2d-49.3757462!3d-25.4520663!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40abf5a9a3778f89%3A0x8398cf976d4abc44!2sDr%20Gilberto%20Cascaes%20Infectologista!5e0!3m2!1spt-BR!2sbr!4v1718130000000!5m2!1spt-BR!2sbr"
            width="840"
            height="400"
            style={{ border: 0, borderRadius: "16px" }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>

      <div className="section about no-padding-mobile">
        <div style={{ padding: "24px 48px" }}>
          <h2 className="section-header white">Opiniões dos pacientes</h2>
          <hr className="divider-bar" style={{ marginBottom: "24px" }} />
        </div>
        <EmblaCarousel slides={googleReviews} options={{ loop: true }} />
      </div>

      <div className="section faq">
        <h2 className="section-header ">Perguntas Frequentes</h2>
        <hr className="divider-bar strong" />
        <h3>• Como faço para agendar uma consulta?</h3>
        <p>
          Você pode agendar através do{" "}
          <a
            href="https://www.doctoralia.com.br/gilberto-cascaes-guedes-neto/infectologista-especialista-em-clinica-medica/foz-do-iguacu"
            target="_blank"
            rel="noreferrer"
          >
            Doctoralia
          </a>{" "}
          ou entrar em contato via{" "}
          <a
            href="https://wa.me/+5541987895126?text=Olá%2C%20gostaria%20de%20agendar%20uma%20consulta."
            target="_blank"
            rel="noreferrer"
          >
            WhatsApp
          </a>{" "}
          . É rápido e fácil!
        </p>
        <h3>• O plano de saúde é aceito?</h3>
        <p>
          Atendimento particular com emissão de Nota Fiscal para reembolso pelos
          planos (consulte a política de reembolso do seu plano!)
        </p>
        <h3>• Qual o valor da consulta particular?</h3>
        <p>
          A partir de 350 reais a depender da modalide (teleconsulta, presencial
          ou domiciliar)
        </p>
      </div>

      <div id="contato" className="contato section">
        <h2 className="section-header white">Agendamento e Contato</h2>
        <hr className="divider-bar" />
        <p className="white bold">
          Não deixe sua saúde para depois. Agende sua consulta e tenha um
          diagnóstico preciso com um especialista que realmente se importa.
        </p>
        <div className="icons">
          <a
            href="https://www.doctoralia.com.br/gilberto-cascaes-guedes-neto/infectologista-especialista-em-clinica-medica/foz-do-iguacu"
            target="_blank"
            rel="noreferrer"
          >
            <img
              className="doctoralia"
              src={doctoralia}
              alt={"doctoraliaIcon"}
            />
          </a>
          <a
            href="https://wa.me/+5541987895126?text=Olá%2C%20gostaria%20de%20agendar%20uma%20consulta."
            target="_blank"
            rel="noreferrer"
          >
            <img
              style={{ width: "94px", height: "94px" }}
              className="whats reverse"
              src={whats}
              alt={"whatsIcon"}
            />
          </a>
          <a
            href="https://www.instagram.com/dr.gilbertoinfecto/"
            target="_blank"
            rel="noreferrer"
          >
            <img
              className="instagram reverse"
              src={instagram}
              alt={"instagramIcon"}
            />
          </a>

          <a
            href="https://www.google.com/maps/place/Dr+Gilberto+Cascaes+Infectologista/@-25.4520663,-49.3757462,65977m/data=!3m1!1e3!4m18!1m9!3m8!1s0x40abf5a9a3778f89:0x8398cf976d4abc44!2sDr+Gilberto+Cascaes+Infectologista!8m2!3d-25.4951166!4d-49.2897982!9m1!1b1!16s%2Fg%2F11x7wjbwt0!3m7!1s0x40abf5a9a3778f89:0x8398cf976d4abc44!8m2!3d-25.4951166!4d-49.2897982!9m1!1b1!16s%2Fg%2F11x7wjbwt0?entry=ttu&g_ep=EgoyMDI1MDkwNy4wIKXMDSoASAFQAw%3D%3D"
            target="_blank"
            rel="noreferrer"
          >
            <img className="google reverse" src={google} alt={"googleIcon"} />
          </a>
          <a
            href="https://www.tiktok.com/@gilberto.cascaes0"
            target="_blank"
            rel="noreferrer"
          >
            <img className="tiktok reverse" src={tiktok} alt={"tiktokIcon"} />
          </a>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default App;
